export const AVAILABLE = 'AVAILABLE';
export const UNAVAILABLE = 'UNAVAILABLE';
export const COMPLETED = 'COMPLETED';
export const ENROLLED = 'ENROLLED';
export const MANAGE = 'MANAGE';
export const UNENROLL = 'UNENROLL';
